import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative bg-dark py-16 lg:py-24 overflow-hidden flex items-center justify-center" data-id="element-30">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-primary/5 pointer-events-none" data-id="element-31"></div>

      <div className="max-w-[800px] mx-auto px-5 relative z-10 text-center flex flex-col items-center w-full" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="w-full flex flex-col items-center" data-id="element-33">
          <h2 className="font-serif text-[32px] md:text-[48px] text-primary leading-tight mb-4 lg:mb-6" data-id="element-34">
            Tu alimentación merece ser personal
          </h2>
          <p className="text-[15px] md:text-[18px] text-primary/70 font-light mb-8 lg:mb-10 max-w-[500px]" data-id="element-35">
            3 minutos de evaluación. Un nutriólogo que entiende tu vida. Un plan
            que realmente puedas seguir.
          </p>

          <motion.button whileTap={{
          scale: 0.96
        }} className="w-full sm:w-auto bg-white text-dark uppercase text-[14px] font-bold tracking-wide py-4 lg:py-5 px-8 lg:px-10 rounded-full flex items-center justify-center space-x-2 hover:bg-primary transition-all mx-auto min-h-[56px] shadow-lg mb-8" data-id="element-36">
            <span data-id="element-37">Hacer la evaluación gratuita →</span>
          </motion.button>

          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6" data-id="element-38">
            {['Sin compromiso · No pedimos tarjeta', 'Resultado inmediato al finalizar el test', 'Si decides continuar, pagas desde $499 MXN'].map(t => <span key={t} className="flex items-center space-x-2 text-[12px] text-primary/60" data-id="element-39">
                <Check className="w-4 h-4 text-accent-secondary shrink-0" data-id="element-40" />
                <span data-id="element-41">{t}</span>
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}